export default __webpack_public_path__ + "static/media/promos-icon-active.f15458f1.webp";